import { DashboardCardDescription } from '@Dashboard/Layout/DashboardCard';
import { Box, Divider } from '@tonic-one/react';
import { t } from 'i18next';
import SpamGraymailRecipientsChart from './chart';
import SpamGraymailRecipientsTable from './table';

const SpamGraymailRecipients = (props: { day: string; insightsData: any }) => {
  return (
    <Box>
      <DashboardCardDescription>
        {t('riskUser.recipient.spammerDesc')}
      </DashboardCardDescription>
      <SpamGraymailRecipientsChart
        insightsData={props.insightsData}
        day={props.day}
      />
      <Divider orientation="horizontal" position="relative" mb="24px" />
      <SpamGraymailRecipientsTable
        insightsData={props.insightsData}
        day={props.day}
      />
    </Box>
  );
};

export default SpamGraymailRecipients;
